/**
 * Formatage en français, dans le fuseau de la ville.
 *
 * Partagé entre le Worker (contenu HTML servi aux robots et aux navigateurs sans JavaScript) et le client :
 * une même donnée doit s'écrire exactement pareil des deux côtés, sinon le texte indexé ne correspond plus
 * à ce que voit le lecteur.
 */
const formatters = new Map<string, Intl.DateTimeFormat>();

function formatter(timeZone: string, name: string, options: Intl.DateTimeFormatOptions): Intl.DateTimeFormat {
  const key = `${name}:${timeZone}`;
  const found = formatters.get(key);
  if (found !== undefined) return found;
  const built = new Intl.DateTimeFormat('fr-FR', { ...options, timeZone });
  formatters.set(key, built);
  return built;
}

/** Une date illisible ne doit jamais faire échouer un rendu : on n'affiche rien. */
function safe(format: Intl.DateTimeFormat, iso: string): string {
  const time = Date.parse(iso);
  return Number.isNaN(time) ? '' : format.format(time);
}

/** « 14:05 » */
export function formatTimeIn(iso: string, timeZone: string): string {
  return safe(formatter(timeZone, 'time', { hour: '2-digit', minute: '2-digit' }), iso);
}

/** « mardi 24 septembre 2026 » */
export function formatDayIn(iso: string, timeZone: string): string {
  return safe(formatter(timeZone, 'day', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }), iso);
}

/** « mar. 24 sept. 14:05 » */
export function formatDayTimeIn(iso: string, timeZone: string): string {
  return safe(
    formatter(timeZone, 'dayTime', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }),
    iso,
  );
}
